import { getLocalization } from 'global/global';
import { CURRENCY, TransactionPrices } from 'Interfaces/PaymentPlanInterface';
import * as React from 'react';
import { Col, Form, } from 'react-bootstrap';

interface Props {
  value: string;
  transactionPrices: TransactionPrices;
  currency: CURRENCY;
  onChange: (value: string | null) => void;
}

export default function TransactionBundle(props: Props) {
  const { currency } = props;
  const onClick = (value) => {
    if (props.value === value) {
      props.onChange(null);
    }
  };

  const currencySign = React.useMemo(() => {
    switch (currency) {
      case CURRENCY.EUR:
        return '€';
      default:
        return '$';
    }
  }, [currency]);

  return (
    <Form.Group as={Col}>
      <Form.Label>{getLocalization('transactionBundle')}</Form.Label>
      {props.transactionPrices.map(tp => (
        <Form.Check
          key={`tx-bundle-${tp.transactionCount}`}
          id={`tx-bundle-${tp.transactionCount}`}
          type={'radio'}
          label={`${tp.transactionCount} ${getLocalization('transactions')} - ${currencySign}${tp.price}`}
          name={'tx-bundle'}
          checked={`${props.value}` === `${tp.transactionCount}`}
          onChange={(e) => props.onChange(e.target.checked ? `${tp.transactionCount}` : null )}
          onClick={() => onClick(`${tp.transactionCount}`)}
        />
      ))}
    </Form.Group>
  );
}
